import * as React from "react";
import { Layout, AppBar } from "react-admin";
import { Box, Typography } from "@mui/material";

const DarkThemeAppBar = (props) => (
  <AppBar style={{ background: "#2b005e" }} {...props}>
    <Box flex="1">
      <Typography
        variant="h6"
        id="react-admin-title"
        style={{ position: "relative" }}
      >
        <img
          style={{
            height: 30,
            display: "block",
            marginInline: "auto",
            position: "absolute",
            right: "45%",
          }}
          src="https://sales.matchbet.io/wp-content/uploads/2022/12/matchbet-line.png"
          alt="matchbet"
        />
      </Typography>
    </Box>
  </AppBar>
);

const DarkThemeLayout = (props) => (
  <Layout {...props} appBar={DarkThemeAppBar} />
);

export default DarkThemeLayout;
